import { render, staticRenderFns } from "./VerificationEmail.vue?vue&type=template&id=24c11c35&scoped=true&"
import script from "./VerificationEmail.vue?vue&type=script&lang=js&"
export * from "./VerificationEmail.vue?vue&type=script&lang=js&"
import style0 from "./VerificationEmail.vue?vue&type=style&index=0&id=24c11c35&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c11c35",
  null
  
)

export default component.exports